import { createContext, useContext, ReactNode } from "react";
import { getPalette } from "./index";
import typography from "./typography";
import overrides from "./overrides";
import { useColorTheme } from "./useColorTheme";
import { getSystemThemePref } from "../../utils";

export type ThemeMode = "light" | "dark" | "system";

type FlozyTheme = {
  palette: any;
  overrides: any;
  typography: any;
};

export interface ThemeContextValue {
  mode: ThemeMode;
  toggleColorMode: (newType: ThemeMode) => void;
  theme: FlozyTheme;
  isPendingChanges?: boolean;
  saveThemeChanges?: () => void;
  selectedThemeType?: ThemeMode;
  changeMode?: (theme: ThemeMode) => void;
}

const mode: ThemeMode =
  (localStorage.getItem("themeType") as ThemeMode) || "system";

export const ThemeContext = createContext<ThemeContextValue>({
  mode,
  toggleColorMode: () => {},
  theme: {
    palette: getPalette(mode === "system" ? getSystemThemePref() : mode) as any,
    overrides: overrides as any,
    typography: typography as any,
  },
});

interface ThemeContextProviderProps {
  children: ReactNode;
}

export const ThemeContextProvider = ({
  children,
}: ThemeContextProviderProps) => {
  const value = useColorTheme() as ThemeContextValue;
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useThemeContext = (): ThemeContextValue => {
  return useContext(ThemeContext);
};
